"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetExperimentsResponseToJSON = exports.GetExperimentsResponseFromJSONTyped = exports.GetExperimentsResponseFromJSON = exports.instanceOfGetExperimentsResponse = void 0;
var runtime_1 = require("../runtime");
var Experiment_1 = require("./Experiment");
var Paging_1 = require("./Paging");
/**
 * Check if a given object implements the GetExperimentsResponse interface.
 */
function instanceOfGetExperimentsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetExperimentsResponse = instanceOfGetExperimentsResponse;
function GetExperimentsResponseFromJSON(json) {
    return GetExperimentsResponseFromJSONTyped(json, false);
}
exports.GetExperimentsResponseFromJSON = GetExperimentsResponseFromJSON;
function GetExperimentsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paging': !(0, runtime_1.exists)(json, 'paging') ? undefined : (0, Paging_1.PagingFromJSON)(json['paging']),
        'experiments': !(0, runtime_1.exists)(json, 'experiments') ? undefined : (json['experiments'].map(Experiment_1.ExperimentFromJSON)),
    };
}
exports.GetExperimentsResponseFromJSONTyped = GetExperimentsResponseFromJSONTyped;
function GetExperimentsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paging': (0, Paging_1.PagingToJSON)(value.paging),
        'experiments': value.experiments === undefined ? undefined : (value.experiments.map(Experiment_1.ExperimentToJSON)),
    };
}
exports.GetExperimentsResponseToJSON = GetExperimentsResponseToJSON;
